module.exports = __webpack_public_path__ + "img/alert-octagon.dc065117.svg";